// extracted by mini-css-extract-plugin
export default {"footer":"Footer-module--footer--bfdf8","copyright":"Footer-module--copyright--8705d"};